import { gql } from 'graphql-request';

import {
  CategoryID,
  CategoryUUID,
  CategoryLocalizedName
} from '../../categories/categoriesTypes';

export interface CacheFetchProfileCategoriesQueryResponse {
  uuid: CategoryUUID;
  id: CategoryID;
  localizedName: CategoryLocalizedName;
}

export const CACHE_FETCH_PROFILE_CATEGORIES_QUERY = gql`
  query CacheUserProfileCategories(
    $filters: CategoriesFilters
    $sort: [CategoriesSortEnum!]
    $limit: Int
    $offset: Int
    $source: String
    $trackTotalHits: Boolean
  ) {
    categories(
      filters: $filters
      sort: $sort
      limit: $limit
      offset: $offset
      source: $source
      trackTotalHits: $trackTotalHits
    ) {
      nodes {
        id
        uuid
        localizedName
      }
      paginationInfo {
        nextPage
        totalCount
      }
    }
  }
`;
